
  <h1 class="visually-hidden">QuizTime Question Presenter</h1>
  <app-global-loader></app-global-loader>
  <router-outlet></router-outlet>
